import { ActivatedRouteSnapshot } from '@angular/router';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { clientConfigAppGuard } from '../guards';
import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [
        {
            path: 'horseracing',
            loadChildren: () => import('@frontend/horseracing').then((t) => t.HorseracingRoutesModule),
            canActivate: [(route: ActivatedRouteSnapshot) => clientConfigAppGuard(route)],
            data: { product: ClientConfigProductName.HORSERACING },
        },
    ],
};

export default routes;
